<template>
  <div id="contenedor-agregar-asuntos-minuta">
    <v-form>
      <v-row>
        <v-col cols="12">
          <custom-select
            v-model="idTema"
            label="Tema"
            :items="getContratosTemas"
            item-text="descripcion"
            item-value="id"
            append-outer-icon="mdi-plus-circle"
            @click:append-outer="mostrarAgregarTema = true"
            >
          </custom-select>
        </v-col>
        <v-col>
          <custom-select
            v-model="idSubTema"
            label="SubTema"
            :items="getContratoSubTemas"
            item-text="descripcion"
            item-value="id"
            append-outer-icon="mdi-plus-circle"
            @click:append-outer="handleAddNewSubTema"
            >
          </custom-select>
        </v-col>
      </v-row>
      <v-list>
        <v-subheader>
          Asuntos pendientes
          <v-spacer></v-spacer>
          <v-btn text small rounded @click="mostrarAgregarAsunto = true" :disabled="!idSubTema">
            <v-icon small left>mdi-plus</v-icon>
            Agregar Asunto
          </v-btn>
        </v-subheader>
        <v-list-item
          v-for="asunto in getContratoAsuntos"
          :key="asunto.id"
          >
          <v-list-item-action>
            <v-checkbox
              :value="asuntoAlreadyAdded(asunto)"
              @click="addAsuntoMinuta(asunto)"
              :disabled="asuntoAlreadyAdded(asunto)">
            </v-checkbox>
          </v-list-item-action>
          <v-list-item-content :class="asuntoAlreadyAdded(asunto)
            ? 'text-decoration-line-through text--disabled'
            : ''">
            <v-list-item-title>
              {{ asunto.numero }}.-
              {{ asunto.descripcion }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ asunto.responsables }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-spacer></v-spacer>
            <v-chip>
              {{ asunto.lastContratoMinutaAsunto.porcentaje }}%
            </v-chip>
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="!getContratoAsuntos.length">
          <v-alert>
            No hay asuntos pendientes
          </v-alert>
        </v-list-item>
      </v-list>
    </v-form>
    <v-dialog v-model="mostrarAgregarAsunto" width="500">
      <AgregarAsunto
        v-if="idTema && idSubTema"
        :idTema="idTema"
        :idSubTema="idSubTema"
        v-on:asunto-agregado="nuevoAsuntoAgregado()"
        v-on:cerrar="cerrarAgregarAsunto"
      />
    </v-dialog>
    <v-dialog
      v-model="mostrarAgregarTema"
      width="500">
      <AgregarContratoTema :id-contrato="idContrato" v-on:cerrar="cerrarAgregarTema">
      </AgregarContratoTema>
    </v-dialog>
    <v-dialog
      v-model="mostrarAgregarSubtema"
      width="500"
      persistent>
      <AgregarContratoSubtema
        :id-tema="idTema"
        :id-contrato="idContrato"
        v-on:cerrar="cerrarAgregarSubtema">
      </AgregarContratoSubtema>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CustomSelect from '@/components/inputs/sinColumnas/Select.vue';
import AgregarAsunto from '@/components/administracion/contratos/contrato/asuntos/Agregar.vue';
import CONTRATOS_TEMAS from '@/graphql/querys/administracion/contratos/contrato/temas/contratoTemas.gql';
import CONTRATOS_SUBTEMAS from '@/graphql/querys/administracion/contratos/contrato/subtemas/contratoSubTemas.gql';
import CONTRATOS_ASUNTOS from '@/graphql/querys/administracion/contratos/contrato/asuntos/contratoAsuntos.gql';
import AGREGA_CONTRATO_MINUTA_ASUNTO from '@/graphql/mutations/administracion/minutas/asuntos/agregarContratoMinutaAsunto.gql';
import CONTRATO_MINUTA_ASUNTOS from '@/graphql/querys/administracion/minutas/contratoMinutaAsuntos.gql';
import AgregarContratoTema from '@/components/administracion/contratos/contrato/temas/Agregar.vue';
import AgregarContratoSubtema from '@/components/administracion/contratos/contrato/subtemas/Agregar.vue';

export default {
  name: 'AgregarMinutasAsuntos',
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    idMinuta: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomSelect,
    AgregarAsunto,
    AgregarContratoTema,
    AgregarContratoSubtema,
  },
  data() {
    return {
      idTema: null,
      idSubTema: null,
      mostrarAgregarAsunto: false,
      mostrarAgregarTema: false,
      mostrarAgregarSubtema: false,
    };
  },
  apollo: {
    contratoTemas: {
      query: CONTRATOS_TEMAS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoSubTemas: {
      query: CONTRATOS_SUBTEMAS,
      variables() {
        return {
          idTema: this.idTema,
        };
      },
      skip() {
        return !this.idTema;
      },
    },
    contratoAsuntos: {
      query: CONTRATOS_ASUNTOS,
      variables() {
        return {
          idSubTema: this.idSubTema,
        };
      },
      skip() {
        return !this.idSubTema;
      },
    },
    contratoMinutaAsuntos: {
      query: CONTRATO_MINUTA_ASUNTOS,
      variables() {
        return {
          idMinuta: this.idMinuta,
        };
      },
    },
  },
  mounted() {
    eventBus.$on('contrato-subtema-agregado', async () => {
      await this.$apollo.queries.contratoSubTemas.refetch({
        idTema: this.idTema,
      });
    });
  },
  methods: {
    cerrarAgregarTema() {
      this.mostrarAgregarTema = false;
    },
    handleAddNewSubTema() {
      if (!this.idTema) {
        return;
      }

      this.mostrarAgregarSubtema = true;
    },
    cerrarAgregarSubtema() {
      this.mostrarAgregarSubtema = false;
    },
    async addAsuntoMinuta(asunto) {
      if (this.asuntoAlreadyAdded(asunto)) {
        return;
      }

      await this.$apollo.mutate({
        mutation: AGREGA_CONTRATO_MINUTA_ASUNTO,
        variables: {
          minutaAsunto: {
            idMinuta: this.idMinuta,
            idContratoAsunto: asunto.id,
            porcentaje: asunto.lastContratoMinutaAsunto.porcentaje,
            accionesRequeridas: asunto.lastContratoMinutaAsunto.accionesRequeridas,
          },
        },
      }).then(() => {
        this.$apollo.queries.contratoAsuntos.refetch({
          idSubTema: this.idSubTema,
        });

        this.mixMensajeSuccess();
        this.$emit('asunto-agregado');
        this.$emit('acuerdos-vencidos-actualizar');
      }).catch((err) => {
        this.mixMensajeError(err);
      });
    },
    asuntoAlreadyAdded(asunto) {
      return this.getMinutaAsuntos
        .some((minutaAsunto) => minutaAsunto.idContratoAsunto === asunto.id);
    },
    nuevoAsuntoAgregado() {
      this.$apollo.queries.contratoAsuntos.refetch({
        idSubTema: this.idSubTema,
      });
    },
    cerrarAgregarAsunto() {
      this.mostrarAgregarAsunto = false;
    },
    ordenarPorValor(a, b) {
      if (Number(a) && Number(b)) {
        return Number(a) - Number(b);
      }

      return a.localeCompare(b);
    },
  },
  computed: {
    getContratosTemas() {
      if (!this.contratoTemas) {
        return [];
      }
      return this.contratoTemas
        .slice()
        .sort((a, b) => this.ordenarPorValor(a.clave, b.clave))
        .map((tema) => ({
          id: tema.id,
          descripcion: `${tema.clave} ${tema.descripcion}`,
        }));
    },
    getContratoSubTemas() {
      if (!this.contratoSubTemas) {
        return [];
      }
      return this.contratoSubTemas
        .slice()
        .sort((a, b) => this.ordenarPorValor(a.descripcion, b.descripcion));
    },
    getContratoAsuntos() {
      if (!this.contratoAsuntos) {
        return [];
      }
      return [...this.contratoAsuntos.map((asunto) => ({
        ...asunto,
        lastContratoMinutaAsunto: asunto.lastContratoMinutaAsunto
          ? asunto.lastContratoMinutaAsunto
          : {
            idContratoAsunto: asunto.id,
            porcentaje: 0,
            accionesRequeridas: '',
          },
      }))]
        .filter((asunto) => asunto.lastContratoMinutaAsunto.porcentaje < 100)
        .sort((a, b) => this.ordenarPorValor(a.numero, b.numero));
    },
    getMinutaAsuntos() {
      if (!this.contratoMinutaAsuntos) {
        return [];
      }
      return this.contratoMinutaAsuntos;
    },
  },
  watch: {
    idSubTema() {
      this.$apollo.queries.contratoAsuntos.refetch({
        idSubTema: this.idSubTema,
      });
    },
  },
};
</script>

<style lang="scss">

</style>
